import {
  apiRequest,
  PemadananList,
  PemadananExport,
} from "../../../../../services/adapters/kepegawaian/pemadananService";

class DataTableRepository {
  fetchRowTable = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      PemadananList,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchExport = async (query) => {
    return await apiRequest(
      "get",
      PemadananExport,
      {
        params: query,
      },
      true
    );
  };
}
export default DataTableRepository;
